export const Accordion = (() => {
	'use strict';

	function init() {
		
		var $drawer = $('.drawer');
		var $toggle = $('.drawer-toggle');
		
		$toggle.on('click',function(event){

			event.preventDefault();
			var href = $(this).attr('href');
			
				$drawer.hide();
				$('.drawer[data-title*="'+href+'"]').show();

				$toggle.removeClass('active');
				$(this).addClass('active');
			
		})

		$($toggle).eq(0).trigger('click');
		
	}

	return {
		init: init,
		name: 'accordion'
	};
})();
